import { Component } from '@angular/core';
import { build } from '../../../build';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
})
export class FooterComponent {
    protected readonly hash = build.hash;

    // build.time is `YYMMDD.HHmm` UTC (stamped by version.mjs); reformat as `YYYY-MM-DD HH:mm`.
    protected readonly builtAt = `20${build.time.slice(0, 2)}-${build.time.slice(2, 4)}-${build.time.slice(4, 6)} ${build.time.slice(7, 9)}:${build.time.slice(9, 11)}`;
}
